module.exports = __webpack_public_path__ + "static/rotating-schedule-df0cb4b00758ce84c4b319ae56cb30d4.jpeg";